




























import { Season } from '@/models/geek-profile';
import Vue from 'vue';

export default Vue.extend({
  name: 'SeasonSelect',
  props: {
    activeSeason: Object as () => Season,
    seasons: Array as () => Season[],
  },
  methods: {
    setSeason(season: Season) {
      this.$emit('setSeason', season);
    },
    getSeasonEndDate(season: Season): string {
      return !season.isGlobal ? `(${(this as any).$options.filters.formattedDate(season.end)})` : '';
    },
  },
});
